/*
 * Copyright (c) 2021. Dave van Rijn Development
 */
import './style/dvrdPassword.scss';

import React, {PureComponent} from 'react';
import {AwesomeIcon, ElementPosition} from '@dvrd/dvr-controls';
import DvrdInputController, {InputControllerProps} from "./dvrdInputController";


interface State {
    type: 'password' | 'text';
}

export default class DvrdPasswordInput extends PureComponent<InputControllerProps, State> {
    state: State = {
        type: 'password',
    };

    onClickOrnament = () => {
        const {type} = this.state;
        if (type === 'password') this.setState({type: 'text'});
        else this.setState({type: 'password'});
    };

    renderOrnament = () => {
        const {type} = this.state, element = type === 'password' ? 'eye' : 'eye-slash';
        return {
            placement: ElementPosition.RIGHT,
            element: <AwesomeIcon name={element} onClick={this.onClickOrnament} className='dvrd-password-toggle'/>
        };
    };

    render = () => {
        const {type} = this.state, {inputProps} = this.props;
        return (
            <DvrdInputController {...this.props} inputProps={{...inputProps, type}} ornaments={this.renderOrnament()}/>
        );
    }
}